import { useCallback } from 'react'
import { Requirement } from '../../../typings'
import { useClosingReqContext } from '../../../context'
import { setActiveRequirementActionCreator } from '../../../state'

export function useHandlers(props: {
  disabled?: boolean
  linkClick?: () => void
  requirement: Requirement
}) {
  const { disabled, linkClick, requirement } = props

  const [{ activeRequirement }, dispatch] = useClosingReqContext()

  const clickHandler = useCallback(() => {
    if (activeRequirement === requirement) {
      dispatch(setActiveRequirementActionCreator(undefined))
    } else {
      dispatch(setActiveRequirementActionCreator(requirement))
      linkClick?.()
    }
  }, [activeRequirement, dispatch, linkClick, requirement])

  const onClick = disabled ? undefined : clickHandler

  return {
    onClick,
  }
}
